{
  "exitDemoButton": "Exit Demo",
  "exploreTheAppInDemoMode": "Explore the FarmHQ App using a Demo Farm:",
  "indicatorText": {
    "isEnabled": "Demo Mode"
  },
  "isActiveText": "Demo Mode Active",
  "loadDemoButton": "Load Demo",
  "permissionDenied": "This feature is disabled in Demo Mode.",
  "toasts": {
    "isEnabled": "Demo mode enabled"
  },
  "tryTheDemo": "Try the Demo",
  "warnings": {
    "someFeaturesDisabled": "This is a demo of the FarmHQ app. Certain features are disabled."
  }
}
